module.exports = __webpack_public_path__ + "static/media/2019Day2.0e213121.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/App/images/2019Day2.JPG
// module id = 189
// module chunks = 0